import { render, staticRenderFns } from "./DialogCancel.vue?vue&type=template&id=08038b5f"
import script from "./DialogCancel.vue?vue&type=script&lang=js"
export * from "./DialogCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports